export default __webpack_public_path__ + "static/media/medalha-prata.4eef31ab.svg";